import { render, staticRenderFns } from "./PromiseOfFreshness.vue?vue&type=template&id=2083a17c&scoped=true"
import script from "./PromiseOfFreshness.vue?vue&type=script&lang=js"
export * from "./PromiseOfFreshness.vue?vue&type=script&lang=js"
import style0 from "./PromiseOfFreshness.vue?vue&type=style&index=0&id=2083a17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083a17c",
  null
  
)

export default component.exports